import { render, staticRenderFns } from "./footerNew.pc.vue?vue&type=template&id=c859a856&scoped=true"
import script from "./footerNew.pc.vue?vue&type=script&lang=js"
export * from "./footerNew.pc.vue?vue&type=script&lang=js"
import style0 from "./footerNew.pc.vue?vue&type=style&index=0&id=c859a856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c859a856",
  null
  
)

export default component.exports